import {
  FETCH_PRODUCT_BRAND_LIST,
  RESET_PRODUCT_BRAND_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const productBrandListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_BRAND_LIST:
      return { list: action.payload, others: action.others };
    case RESET_PRODUCT_BRAND_LIST: {
      return initialState;
    }
    default:
      return state;
  }
};

export default productBrandListReducer;
